/*
 *  ih.scripts, ih.loadScript, ih.loadScripts, ih.require
 *
 * Simple dependency manager and script injector
 *
 *  Depends:
 *      ih
 *      jQuery
 *
 *
 * Usage:
 * 
 * <script>
 *     (function($) {
 *     
 *          // load a single script:
 *          ih.require("/js/app/web/some-script.js");
 *          
 *          // with a callback
 *          ih.require("/js/app/web/some-script.js", function() {
 *              console.log("some-script.js has loaded!");
 *          });
 *          
 *          // load multiple files and execute in sequence,
 *          // then callback
 *          ih.require([
 *              "https://somecdn.com/some-library.js", 
 *              "/js/lib/some-library/some-plugin.js", 
 *          ],
 *          function() {
 *              console.log("all dependencies have loaded. Initializing instances");
 *              $(".my-elements").somePlugin();
 *          });
 *          
 *          
 *          
 *          // Note how the following are functionally equivalent.
 *          
 *          ih.require("some.js", function() {
 *              // callback
 *          });
 *          
 *          $.while( ih.loadScript("some.js") ).done(function() {
 *              // callback
 *          });
 *     
 *     })(jQuery);
 * </script>
 * 
 * 
 * 
 *  You can also create script tags with a data-require attribute 
 *  instead of a src attribute
 *
 *  <div class="some_widget">
 *      <script data-require="/some/path/to/file.js"></script>
 *  </div>
 *
 *  Or you can use a comma delimited list of files -
 *  though it's better to pre-compile them down to a single file ahead of time.
 *
 *  <div class="some_widget">
 *      <script data-require="/some/path/to/file1.js, /some/path/to/file2.js"></script>
 *  </div>
 *
 *
 */
(function($) {
    
    
    var debug = false;
    
    
    
    // keeps track of the scripts that are loading/loaded
    // using a collection of promises (indexed by src)
    // https://api.jquery.com/jquery.when/
    ih.scripts = {}; 
    
    
    // injects a single script. 
    // if a script has already been requested, it will not be requested again.
    // async true means it will execute as soon as it finishes loading,
    // irrespective of any other scripts.
    // async is true by default
    // returns a promise that gets resolved when the script is loaded
    ih.loadScript = function(src, async) {
        var src = ih.staticurl(src);
        
        if ( ih.scripts[src] === undefined ) {
            
//            ih.scripts[src] = $.ajax({
//                url: src,
//                dataType: "script",
//                cache: true
//            });
            if (debug) console.log("loadScript(): loading", src);
            
            ih.scripts[src] = $.Deferred();

            var script = document.createElement('script');
            script.src = src;
            script.async = ( async !== undefined ) ? async : true;
            script.onload = function() {
                ih.scripts[src].resolve();
            }
            script.onerror = function() {
                ih.scripts[src].reject();
            }
            document.getElementsByTagName('head')[0].appendChild(script);
        }
        else {
            if (debug) console.log("loadScript(): use cached", src);
        }
        
        return ih.scripts[src].promise();
//        return ih.scripts[src];
    };
    
    // injects multiple scripts that should load in parallel 
    // and then execute in serial. (async is false by default)
    // src expects a comma delimited string or an array of strings
    // returns a promise that gets resolved when all the scripts have loaded.
    ih.loadScripts = function(src, async) {
//        if (debug) console.log("loadScripts()", src);
        var group = $.Deferred(); // one promise to rule them all
        var promises = [];
        var async = ( async !== undefined ) ? async : false;
        var sources = [];
        var source;
        
        // array
        if ( Object.prototype.toString.call( src ) === '[object Array]' ) {
            sources = src;
        }
        // comma delimited string
        else if ( src.indexOf(",") > 0 ) {
            sources = src.split(",");
        }
        // bad
        else {
            console.error("src should be a comma delimted string or an array");
        }
        
        while( source = sources.shift() ) {
            promises.push( ih.loadScript(source.trim(), async) );
        }
        
        $.when.apply($, promises).then( function() {
            group.resolve();
        });
        
        return group.promise();
    };
    
    
    // just a wrapper around ih.loadScript/ih.loadScripts that allows for a callback
    // src can be an array, a comma delimited string, or a string
    ih.require = function(src, callback) {
        
        if (debug) console.log("require()", src);
        
        var required = $.Deferred();
        
        // array
        if ( Object.prototype.toString.call( src ) === '[object Array]' ) {
            required = ih.loadScripts(src);
        }
        else if ( typeof src === "string" ) {
            // comma delimited string
            if ( src.indexOf(",") > 0 ) {
                required = ih.loadScripts(src);
            }
            // normal string
            else {
                required = ih.loadScript(src);
            }
        }
        else {
            console.error("src should be a string, comma delimted string, or an array");
        }
        
        if ( required && callback !== undefined && $.isFunction(callback) ) {
            $.when( required ).done( function() { callback() } );
        }
    };
    
    
    // run once to add any scripts already in the DOM - 
    // they are assumed to have already loaded
    // All of the major dependencies will fall in this camp like jquery
    $("script[src]").each( function() {
        if ( ! ih.scripts[this.src] ) {
            if (debug) console.log("pre-existing", this.src);
            ih.scripts[this.src] = $.Deferred();
            ih.scripts[this.src].resolve();
        }
    });
    
    // on DOM ready
    $(document).on("ready", function() {
        
        // get any scripts that we missed
        $("script[src]").each( function() {
            if ( ! ih.scripts[this.src] ) {
                if (debug) console.log("pre-existing", this.src);
                ih.scripts[this.src] = $.Deferred();
                ih.scripts[this.src].resolve();
            }
        });
        
        // find any scripts with a data-require attribute 
        // (instead of a src attribute) and inject them 
        $("script[data-require]").each( function() {
            var src = $(this).data("require");
            if (debug) console.log("require-once", src);
            ih.require( src );
            $(this).remove();
        });
    });
    
})(jQuery);
